<template>
    <div class="py-4 container-fluid">
      <h4 class="text-white">SERVICIOS Y MODULOS</h4>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
          <div class="nav-wrapper position-relative end-0">
  <ul class="p-1 bg-transparent nav nav-pills nav-fill">
    <li class="nav-item">
      <a class="mb-3 btn btn-sm w-100" style="cursor: pointer;" :class="{'btn-info': seleccionartap1==true}"
      @click="seleccionartap(1)"><i class="ni ni-cloud-upload-96 mr-2"></i>SERVICIOS</a>
    </li>
    <li class="nav-item">
      <a class="mb-3 btn btn-sm w-100" style="cursor: pointer;" :class="{'btn-info': seleccionartap2==true}"
      @click="seleccionartap(2)"><i class="ni ni-bell-55 mr-2"></i>MODULOS</a>
    </li>
  </ul>
</div>
  <div class="card-body">
    <div class="tab-content">
      <div v-show="seleccionartap1">
         <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-show="vertabla">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      class="form-control"
                      v-model="servi"
                      placeholder="Buscar por nombre"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                      <button
                        @click="ver_formulario()"
                        type="button"
                        class="btn btn-info"
                      >
                        Agregar Servicio
                      </button>
                </div>
                <div class="col-md-3">
                      <button
                        @click="abrirModal()"
                        type="button"
                        class="btn btn-info"
                      >
                        Agregar Sub Servicio
                      </button>
                </div>
              </div>
              <div class="table-responsive"
              >
              <div style="width:auto; height:380px; overflow:auto;">
                <table class="table align-items-center">
                  <thead class="thead-light">
                    <tr>
                      <th class="text-center">SERVICIO</th>
                      <th class="text-center">COLOR</th>
                      <th class="text-center">ICONO</th>
                      <th class="text-center">ESTADO</th>
                      <th class="text-center">INICIAL</th>
                      <th class="text-center">ACCION</th>
                    </tr>
                  </thead>
                  <tbody v-for="(ser, index) in servicios" :key="index">
                    <tr>
                      <td class="text-center">{{ ser.nombre_servicio }}</td>
                      <td class="text-center">{{ ser.color }}</td>
                      <td class="text-center">{{ ser.icono }}</td>
                      <td class="text-center">
                        <div v-if="ser.estado == 'A'">
                <span class="badge badge-sm btn-info">Activo</span>
                        </div>
                        <div v-else-if="ser.estado == 'I'">
                <span class="badge badge-sm bg-gradient-danger">Inactivo</span>
                        </div>
                        <div v-else>
                  <span class="badge badge-sm bg-gradient-secondary">Pendiente</span>
                        </div>
                        </td>
                      <td class="text-center">{{ ser.inicial_servicio }}</td>
                      <td class="text-center">
                        <a type="button" @click="ActualizarNombreServicios(ser)" class="btn btn-sm btn-vimeo btn-icon-only" style="margin-right: 4px;">
                          <i class="fas fa-edit"></i>
                        </a>
                        <a type="button" @click="actualizarestado(ser.id,'S')" class="btn btn-sm btn-danger btn-icon-only" style="margin-right: 4px;">
                          <i class="ni ni-ui-04"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
            </div>
            <!-- -------------------modal----------------------------- -->
    <div
      id="modalllamarturno"
      ref="modalImport"
      class="modal fade"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog mt-lg-7" style="max-width: 1500px !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="ModalLabel" class="modal-title">
              <div class="text-center">
                <h4>REALIZAR LLAMADO DE TURNO SERVICIO
   <a type="button" @click="Agregarnuevosubservicio()" class="btn  btn-info btn-icon-only" style="margin-right: 4px;">
                          <i class="ni ni-fat-add"></i>
                        </a>

                </h4>
               
              </div>
            </h5>
          </div>
          <div class="modal-body">
  <div class="table-responsive"
              >
              <div style="width:auto; height:580px; overflow:auto;">
                <table class="table align-items-center">
                  <thead class="thead-light">
                    <tr>
                      <th class="text-center">SERVICIO</th>
                      <th class="text-center">SUB SERVICIO</th>
                      <th class="text-center">ESTADO</th>
                      <th class="text-center">ACCION</th>
                    </tr>
                  </thead>
                  <tbody v-for="(ser, index) in subservicios" :key="index">
                    <tr>
                      <td class="text-center">{{ ser.nombre_servicio }}</td>
                      <td class="text-center">{{ ser.nombre_sub }}</td>
                      <td class="text-center">
                        <div v-if="ser.estado == 'A'">
                <span class="badge badge-sm btn-info">Activo</span>
                        </div>
                        <div v-else>
                <span class="badge badge-sm bg-gradient-danger">Inactivo</span>
                        </div>
                        </td>
                      <td class="text-center">
                        <!-- <a type="button" @click="actualizarestado(ser.inicial_servicio)" class="btn btn-sm btn-info btn-icon-only" style="margin-right: 4px;">
                          <i class="fas fa-edit"></i>
                        </a>
                        <a type="button" @click="actualizarestado(ser.id,'S')" class="btn btn-sm btn-danger btn-icon-only" style="margin-right: 4px;">
                          <i class="ni ni-ui-04"></i>
                        </a> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              type="button"
              class="btn bg-gradient-danger btn-sm"
              @click="cerrarModal()"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- -------------------modal----------------------------- -->
            <!-- ========= -->
            <div v-show="verformulario">
              <h4 class="text-center">AGREGAR SERVICIO <button
                type="button"
                @click="vertablaservicios()"
                class="btn btn-danger btn-sm float-lg-end"
              >
               <i class="fa fa-arrow-left coloriconos fa-5x"></i>
              </button></h4>
            <div>
              <div class="col-md-4">
                  <h6><strong>Nombre del Servicio</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="nombre_servicio"
                      class="form-control"
                    />
                  </div>
                </div>
                                          <br>
<!-- -------------------------------------------------------------------------------------------------------------------------------------             -->

 <div class="float-lg-end col-md-8">
<i class="ni ni-active-40"></i>
<span class="m-2">ni ni-active-40</span>
<i class="ni ni-air-baloon"></i>
<span class="m-2">ni ni-air-baloon</span>
<i class="ni ni-album-2"></i>
<span class="m-2">ni ni-album-2</span>
<i class="ni ni-align-center"></i>
<span class="m-2">ni ni-align-center</span>
<i class="ni ni-align-left-2"></i>
<span class="m-2">ni ni-align-left-2</span>
<i class="ni ni-ambulance"></i>
<span class="m-2">ni ni-ambulance</span>
<i class="ni ni-app"></i>
<span class="m-2">ni ni-app</span>
<i class="ni ni-archive-2"></i>
<span class="m-2">ni ni-archive-2</span>
<i class="ni ni-atom"></i>
<span class="m-2">ni ni-atom</span>
<i class="ni ni-badge"></i>
<span class="m-2">ni ni-badge</span>
<i class="ni ni-bag-17"></i>
<span class="m-2">ni ni-bag-17</span>
<i class="ni ni-basket"></i>
<span class="m-2">ni ni-basket</span>
<i class="ni ni-bell-55"></i>
<span class="m-2">ni ni-bell-55</span>
<i class="ni ni-bold-down"></i>
<span class="m-2">ni ni-bold-down</span>
<i class="ni ni-bold-left"></i>
<span class="m-2">ni ni-bold-left</span>
<i class="ni ni-bold-right"></i>
<span class="m-2">ni ni-bold-right</span>
<i class="ni ni-bold-up"></i>
<span class="m-2">ni ni-bold-up</span>
<i class="ni ni-bold"></i>
<span class="m-2">ni ni-bold</span>
<i class="ni ni-book-bookmark"></i>
<span class="m-2">ni ni-book-bookmark</span>
<i class="ni ni-books"></i>
<span class="m-2">ni ni-books</span>
<i class="ni ni-box-2"></i>
<span class="m-2">ni ni-box-2</span>
<i class="ni ni-briefcase-24"></i>
<span class="m-2">ni ni-briefcase-24</span>
<i class="ni ni-building"></i>
<span class="m-2">ni ni-building</span>
<i class="ni ni-bulb-61"></i>
<span class="m-2">ni ni-bulb-61</span>
<i class="ni ni-bullet-list-67"></i>
<span class="m-2">ni ni-bullet-list-67</span>
<i class="ni ni-bus-front-12"></i>
<span class="m-2">ni ni-bus-front-12</span>
<i class="ni ni-button-pause"></i>
<span class="m-2">ni ni-button-pause</span>
<i class="ni ni-button-play"></i>
<span class="m-2">ni ni-button-play</span>
<i class="ni ni-button-power"></i>
<span class="m-2">ni ni-button-power</span>
<i class="ni ni-calendar-grid-58"></i>
<span class="m-2">ni ni-calendar-grid-58</span>
<i class="ni ni-camera-compact"></i>
<span class="m-2">ni ni-camera-compact</span>
<i class="ni ni-caps-small"></i>
<span class="m-2">ni ni-caps-small</span>
<i class="ni ni-cart"></i>
<span class="m-2">ni ni-cart</span>
<i class="ni ni-chart-bar-32"></i>
<span class="m-2">ni ni-chart-bar-32</span>
<i class="ni ni-chart-pie-35"></i>
<span class="m-2">ni ni-chart-pie-35</span>
<i class="ni ni-chat-round"></i>
<span class="m-2">ni ni-chat-round</span>
<i class="ni ni-check-bold"></i>
<span class="m-2">ni ni-check-bold</span>
<i class="ni ni-circle-08"></i>
<span class="m-2">ni ni-circle-08</span>
<i class="ni ni-cloud-download-95"></i>
<span class="m-2">ni ni-cloud-download-95</span>
<i class="ni ni-cloud-upload-96"></i>
<span class="m-2">ni ni-cloud-upload-96</span>
<i class="ni ni-compass-04"></i>
<span class="m-2">ni ni-compass-04</span>
<i class="ni ni-controller"></i>
<span class="m-2">ni ni-controller</span>
<i class="ni ni-credit-card"></i>
<span class="m-2">ni ni-credit-card</span>
<i class="ni ni-curved-next"></i>
<span class="m-2">ni ni-curved-next</span>
<i class="ni ni-delivery-fast"></i>
<span class="m-2">ni ni-delivery-fast</span>
<i class="ni ni-diamond"></i>
<span class="m-2">ni ni-diamond</span>
<i class="ni ni-email-83"></i>
<span class="m-2">ni ni-email-83</span>
<i class="ni ni-fat-add"></i>
<span class="m-2">ni ni-fat-add</span>
<i class="ni ni-fat-delete"></i>
<span class="m-2">ni ni-fat-delete</span>
<i class="ni ni-fat-remove"></i>
<span class="m-2">ni ni-fat-remove</span>
<i class="ni ni-favourite-28"></i>
<span class="m-2">ni ni-favourite-28</span>
<i class="ni ni-folder-17"></i>
<span class="m-2">ni ni-folder-17</span>
<i class="ni ni-glasses-2"></i>
<span class="m-2">ni ni-glasses-2</span>
<i class="ni ni-hat-3"></i>
<span class="m-2">ni ni-hat-3</span>
<i class="ni ni-headphones"></i>
<span class="m-2">ni ni-headphones</span>
<i class="ni ni-html5"></i>
<span class="m-2">ni ni-html5</span>
<i class="ni ni-istanbul"></i>
<span class="m-2">ni ni-istanbul</span>
<i class="ni ni-circle-08"></i>
<span class="m-2">ni ni-circle-08</span>
<i class="ni ni-key-25"></i>
<span class="m-2">ni ni-key-25</span>
<i class="ni ni-laptop"></i>
<span class="m-2">ni ni-laptop</span>
<i class="ni ni-like-2"></i>
<span class="m-2">ni ni-like-2</span>
<i class="ni ni-lock-circle-open"></i>
<span class="m-2">ni ni-lock-circle-open</span>
<i class="ni ni-map-big"></i>
<span class="m-2">ni ni-map-big</span>
<i class="ni ni-mobile-button"></i>
<span class="m-2">ni ni-mobile-button</span>
<i class="ni ni-money-coins"></i>
<span class="m-2">ni ni-money-coins</span>
<i class="ni ni-note-03"></i>
<span class="m-2">ni ni-note-03</span>
<i class="ni ni-notification-70"></i>
<span class="m-2">ni ni-notification-70</span>
<i class="ni ni-palette"></i>
<span class="m-2">ni ni-palette</span>
<i class="ni ni-paper-diploma"></i>
<span class="m-2">ni ni-paper-diploma</span>
<i class="ni ni-pin-3"></i>
<span class="m-2">ni ni-pin-3</span>
<i class="ni ni-planet"></i>
<span class="m-2">ni ni-planet</span>
<i class="ni ni-ruler-pencil"></i>
<span class="m-2">ni ni-ruler-pencil</span>
<i class="ni ni-satisfied"></i>
<span class="m-2">ni ni-satisfied</span>
<i class="ni ni-scissors"></i>
<span class="m-2">ni ni-scissors</span>
<i class="ni ni-send"></i>
<span class="m-2">ni ni-send</span>
<i class="ni ni-settings-gear-65"></i>
<span class="m-2">ni ni-settings-gear-65</span>
<i class="ni ni-settings"></i>
<span class="m-2">ni ni-settings</span>
<i class="ni ni-single-02"></i>
<span class="m-2">ni ni-single-02</span>
<i class="ni ni-single-copy-04"></i>
<span class="m-2">ni ni-single-copy-04</span>
<i class="ni ni-sound-wave"></i>
<span class="m-2">ni ni-sound-wave</span>
<i class="ni ni-spaceship"></i>
 <span class="m-2">ni ni-spaceship</span>
<i class="ni ni-square-pin"></i>
<span class="m-2">ni ni-square-pin</span>
<i class="ni ni-support-16"></i>
<span class="m-2">ni ni-support-16</span>
<i class="ni ni-tablet-button"></i>
<span class="m-2">ni ni-tablet-button</span>
<i class="ni ni-tag"></i>
<span class="m-2">ni ni-tag</span>
<i class="ni ni-tie-bow"></i>
<span class="m-2">ni ni-tie-bow</span>
<i class="ni ni-time-alarm"></i>
<span class="m-2">ni ni-time-alarm</span>
<i class="ni ni-trophy"></i>
<span class="m-2">ni ni-trophy</span>
<i class="ni ni-tv-2"></i>
<span class="m-2">ni ni-tv-2</span>
<i class="ni ni-umbrella-13"></i>
<span class="m-2">ni ni-umbrella-13</span>
<i class="ni ni-user-run"></i>
<span class="m-2">ni ni-user-run</span>
<i class="ni ni-vector"></i>
<span class="m-2">ni ni-vector</span>
<i class="ni ni-watch-time"></i>
<span class="m-2">ni ni-watch-time</span>
<i class="ni ni-world"></i>
<span class="m-2">ni ni-world</span>
<i class="ni ni-zoom-split-in"></i>
<span class="m-2">ni ni-zoom-split-in</span>
<i class="ni ni-collection"></i>
<span class="m-2">ni ni-collection</span>
<i class="ni ni-image"></i>
<span class="m-2">ni ni-image</span>
<i class="ni ni-shop"></i>
<span class="m-2">ni ni-shop</span>
<i class="ni ni-ungroup"></i>
<span class="m-2">ni ni-ungroup</span>
<i class="ni ni-world-2"></i>
<span class="m-2">ni ni-world-2</span>
<i class="ni ni-ui-04"></i>
<span class="m-2">ni ni-ui-04</span>
</div>
<!-- -------------------------------------------------------------------------------------------------------------------------------------             -->
                <div class="col-md-4">
                  <h6><strong>Color</strong></h6>
                  <div class="form-group">
                    <input
                      type="color"
                      placeholder="Regular"
                      v-model="color_servicio"
                      class="form-control"
                    />
                  </div>
                </div>
              <div class="col-md-4">
                  <h6><strong>Icono</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="icono_servicio"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <h6><strong>Inicial</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="inicial_servicio"
                      class="form-control"
                    />
                  </div>
                </div>

              </div>
              <!-- =============================================== -->
              
              <!-- =============================================== -->
               <div class="text-center">
              <button type="button" class="btn btn-primary"
              @click="AgregarServicios()">
                  <span>Guardar</span>
                </button>
              </div>

            </div>
            <!-- ========= -->
          </div>
        </div>
      </div>
    </div>
      </div>
<!-- ------------------------------------------------------------------------------- -->
      <div v-show="seleccionartap2">
        <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      class="form-control"
                      v-model="modul"
                      placeholder="Buscar por nombre"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <div class="input-group input-group-merge">
                      <button
                        @click="AgregarModulo()"
                        type="button"
                        class="btn btn-info"
                      >
                        Agregar Modulo
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
              <div style="width:auto; height:380px; overflow:auto;">
                <table class="table align-items-center">
                  <thead class="thead-light">
                    <tr>
                      <th class="text-center">NOMBRE</th>
                      <th class="text-center">CODIGO</th>
                      <th class="text-center">ESTADO</th>
                      <th class="text-center">ACCION</th>
                    </tr>
                  </thead>
                  <tbody v-for="(mo, index) in modulos" :key="index">
                    <tr>
                      <td class="text-center">{{ mo.nombre }}</td>
                      <td class="text-center">{{ mo.codigo }}</td>
                      <td class="text-center">
                        <div v-if="mo.estado == 'A'">
                <span class="badge badge-sm btn-info">Activo</span>
                        </div>
                        <div v-else-if="mo.estado == 'I'">
                <span class="badge badge-sm bg-gradient-danger">Inactivo</span>
                        </div>
                        <div v-else>
                  <span class="badge badge-sm bg-gradient-secondary">Pendiente</span>
                        </div>
                        </td>
                         <td class="text-center">
                        <a type="button" @click="ActualizarNombreModulo(mo)" class="btn btn-sm btn-vimeo btn-icon-only" style="margin-right: 4px;">
                          <i class="fas fa-edit"></i>
                        </a>
                        <a type="button" @click="actualizarestado(mo.id_modulo,'M')" class="btn btn-sm btn-danger btn-icon-only" style="margin-right: 4px;">
                          <i class="ni ni-ui-04"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
<!-- ------------------------------------------------------------------------------- -->

    </div>
  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";
import { Modal } from "bootstrap";
export default {
  name: "profile",
  data() {
    return {
       seleccionartap1:true,
       seleccionartap2:false,
       verformulario:false,
      vertabla:true,
      servicios:"",
      subservicios:"",
      servi:"",
      modulos:"",
      modul:"",
      // ===================
      nombre_servicio:"",
      color_servicio:"",
      icono_servicio:"",
      inicial_servicio:"",

    };
  },
  mounted() {
    this.seleccionartap(1);
  },
   created() {
    this.servicios_activos();
    this.modulos_activos();
  },
    methods: {
      seleccionartap(opcion) {
            switch (opcion) {
              case 1:
              this.seleccionartap1 = true;
              this.seleccionartap2 = false;
              break;
              case 2:
              this.seleccionartap1 = false;
              this.seleccionartap2 = true;
              break;
              default:
            }
          },
             abrirModal() {
      const modalElement = this.$refs.modalImport;
      this.modalInstance = new Modal(modalElement);
      this.modalInstance.show();
      this.sub_servicios_activos();
    },
    cerrarModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },
     servicios_activos() {
        axios.post("llamar_servicios_todos")
          .then((respuesta) => {
            this.servicios = respuesta.data;
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
     sub_servicios_activos() {
        axios.get("sub_servicios")
          .then((respuesta) => {
            this.subservicios = respuesta.data;
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
     Agregarnuevosubservicio() {
       let opciones = "";
      this.servicios.forEach((e) => {
        opciones += `<option value="${e.id}">${e.nombre_servicio}</option>`;
      });
      this.$swal.fire({
        title: "Por favor indique la fecha de ingreso",
        html: `
         <div class="row">
                  <h6><strong>Servicio Presentado</strong></h6>
                  <div class="form-group">
                    <select class="form-select" name="serviciosend" id="serviciosend">
                      <option value="">Seleccionar Servicio</option>
                    ${opciones}
                    </select>
                  </div>
                </div>
           <div class="mb-3">
                      <input type="text" class="form-control lg" name="subserviciosend" id="subserviciosend" placeholder="usuario" />
                    </div>
        `,
        width: "35vw",
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        cancelButtonText: "CANCELAR",
        confirmButtonText: "GUARDAR",
      })
      .then((resultx) => {
        if (resultx.isConfirmed) {
          var datos = {
            idservicio:document.getElementsByName('serviciosend')[0].value,
            nombresubservicio:document.getElementsByName('subserviciosend')[0].value
          };
          if(datos.idservicio == "" || datos.idservicio == null || datos.idservicio == undefined || 
            datos.nombresubservicio == "" || datos.nombresubservicio == null ||datos.nombresubservicio == undefined
           ){
             this.$swal.fire(
          "Intentar de nuevo",
          "Por favor ingrese todos los campos",
          "info");
          return;
           }
           axios.post("agregar_sub_servicios",datos)
          .then((respuesta) => {
            if(respuesta.data.codigo == 0){
                this.$swal.fire("Exito", respuesta.data.mensaje, "success")
                this.sub_servicios_activos();
              }else{
                this.$swal.fire("Info", respuesta.data.mensaje, "error")
              }
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
        } else {
          this.$swal.fire({
            title: "!NOTIFICACION¡",
            text: "DILIGENCIE TODOS LOS CAMPOS",
            type: "warning",
          });
        }
      });
       
    },
     ActualizarNombreServicios(dato) {
      this.$swal.fire({
        title: "Por favor indique la fecha de ingreso",
        html: `
         <div class="row">
           <div class="mb-3">
                      <input type="text" class="form-control lg" value="${dato.nombre_servicio}" name="nombreservicio" id="nombreservicio" placeholder="usuario" />
                    </div>
           <div class="mb-3">
                      <input type="color" class="form-control lg" value="${dato.color}" name="coloricono" id="coloricono" placeholder="usuario" />
                    </div>
           <div class="mb-3">
                      <input type="text" class="form-control lg" value="${dato.icono}" name="iconocolocar" id="iconocolocar" placeholder="usuario" />
                    </div>
        `,
        width: "35vw",
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        cancelButtonText: "CANCELAR",
        confirmButtonText: "ACTUALIZAR",
      })
      .then((resultx) => {
        if (resultx.isConfirmed) {
          var datos = {
            id_servicio:dato.id,
            nombreservicio:document.getElementsByName('nombreservicio')[0].value,
            coloricono:document.getElementsByName('coloricono')[0].value,
            iconocolocar:document.getElementsByName('iconocolocar')[0].value,
          };
          if(
            datos.nombreservicio == "" || datos.nombreservicio == null ||datos.nombreservicio == undefined ||
            datos.coloricono == "" || datos.coloricono == null ||datos.coloricono == undefined ||
            datos.iconocolocar == "" || datos.iconocolocar == null ||datos.iconocolocar == undefined
           ){
             this.$swal.fire(
          "Intentar de nuevo",
          "Por favor ingrese todos los campos",
          "info");
          return;
           }
           axios.post("actualizarservicio",datos)
          .then((respuesta) => {
            if(respuesta.data.codigo == 0){
                this.$swal.fire("Exito", respuesta.data.mensaje, "success")
                this.servicios_activos();
              }else{
                this.$swal.fire("Info", respuesta.data.mensaje, "error")
              }
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
        }
      });
       
    },
     ActualizarNombreModulo(dato) {
      this.$swal.fire({
        title: "Por favor indique la fecha de ingreso",
        html: `
         <div class="row">
           <div class="mb-3">
                      <input type="text" class="form-control lg" value="${dato.nombre}" name="nombremodulosend" id="nombremodulosend" placeholder="usuario" />
                    </div>
        `,
        width: "35vw",
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        cancelButtonText: "CANCELAR",
        confirmButtonText: "ACTUALIZAR",
      })
      .then((resultx) => {
        if (resultx.isConfirmed) {
          var datos = {
            id_modulo:dato.id_modulo,
            nombremodulo:document.getElementsByName('nombremodulosend')[0].value
          };
          if(datos.nombremodulo == "" || datos.nombremodulo == null ||datos.nombremodulo == undefined
           ){
             this.$swal.fire(
          "Intentar de nuevo",
          "Por favor ingrese todos los campos",
          "info");
          return;
           }
           axios.post("actualizarmodulo",datos)
          .then((respuesta) => {
            if(respuesta.data.codigo == 0){
                this.$swal.fire("Exito", respuesta.data.mensaje, "success")
                this.modulos_activos();
              }else{
                this.$swal.fire("Info", respuesta.data.mensaje, "error")
              }
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
        }
      });
       
    },
    modulos_activos() {
        axios.post("llamar_modulos")
          .then((respuesta) => {
            this.modulos = respuesta.data;
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },

    actualizarestado(datoid,tipo) {
this.$swal.fire({
            title: "Actualizar Estado",
            text: "Esta seguro de Cambiar el estado!",
            icon: "info",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Actualizar",
            cancelButtonColor: '#d33',
             html: `<div class="col-md-12">
                    <label class="form-control-label">Servicio</label>
                   <div class="form-group"> 
                   <select name="estado" id="estado" class="form-select">
                   <option value="">Seleccionar Servicio</option>
                   <option value="A">Activo</option>
                   <option value="I">Inactivo</option>
                    </select>
                    </div>
                    </div>`,
          })
          .then((result) => {
            if (result.isConfirmed) {
      const peticion = {
        datoid:datoid,
        tipo:tipo,
        estado: document.getElementsByName('estado')[0].value
      };
       if(peticion.estado == "" || peticion.estado == null || peticion.estado == undefined) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Ingrese Una Contraseña",
          "info");
      } else {
      axios.post("actualizarestadoservicios",peticion)
        .then((respuesta) => {
          console.log(respuesta);
          if(respuesta.data.codigo == 0){
              this.$swal.fire("Exito", respuesta.data.mensaje, "success")
              if(tipo=='S'){
              this.servicios_activos();
              }else if(tipo=='M'){
              this.modulos_activos();
              }
            }else{
              this.$swal.fire("Info", respuesta.data.mensaje, "error")
            }
        }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
            }
}});
    },
     vertablaservicios() {
      this.verformulario = false;
      this.vertabla = true;
    },
    ver_formulario() {
      this.verformulario = true;
      this.vertabla = false;
    },
    AgregarServicios() {
          this.$swal.fire({
            icon:"info",
            title: "Agregar Nuevo Servicio",
            text: "Esta seguro de Agregar este servicio!",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Agregar",
            cancelButtonColor: '#d33'
          })
          .then((result) => {
            if (result.isConfirmed) {
      const peticion = {
        nombre:this.nombre_servicio,
        color:this.color_servicio,
        icono:this.icono_servicio,
        inicial:this.inicial_servicio
      };
      if(peticion.nombre == "" || peticion.nombre == null || peticion.nombre == undefined ||
      peticion.color == "" || peticion.color == null || peticion.color == undefined ||
      peticion.icono == "" || peticion.icono == null || peticion.icono == undefined ||
      peticion.inicial == "" || peticion.inicial == null || peticion.inicial == undefined ) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por Diligenciar todos los datos",
          "info");
      } else {
        axios.post("agregar_servicios",peticion)
          .then((respuesta) => {
            if(respuesta.data.codigo == 0){
                this.$swal.fire("Exito", respuesta.data.mensaje, "success")
                this.servicios_activos();
              }else{
                this.$swal.fire("Info", respuesta.data.mensaje, "error")
              }
          }).catch((error) => {
              if(error.response.status == 400){
                 this.$swal.fire(
                  "Ups!!",
                  "Token Invalido Cierre Session e Ingrese de Nuevo",
                  "error"
                );
              }
            });
      }
}});
    },
    AgregarModulo() {
this.$swal.fire({
            title: "Agregar Nuevo Modulo",
            text: "Esta seguro de Cambiar la clave!",
            width: 1000,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Agregar",
            cancelButtonColor: '#d33',
             html: `<div class="row">
                    <div class="col-md-6">
                    <label class="form-control-label">Nombre Modulo</label>
                   <div class="form-group"> 
                  <input type="text"  placeholder="Escribir Nueva Contraseña" id="nombre_modulo" name="nombre_modulo"  class="form-control"/>
                    </div>
                    </div>
                    <div class="col-md-6">
                    <label class="form-control-label">Numero</label>
                   <div class="form-group"> 
                  <input type="text"  placeholder="Escribir Nueva Contraseña" id="codigo_modulo" name="codigo_modulo"  class="form-control"/>
                    </div>
                    </div>
                    </div>`,
          })
          .then((result) => {
            if (result.isConfirmed) {
      const peticion = {
        nombre: document.getElementsByName('nombre_modulo')[0].value,
        codigo: document.getElementsByName('codigo_modulo')[0].value
      };
      if(peticion.nombre == "" || peticion.nombre == null || peticion.nombre == undefined ||
      peticion.codigo == "" || peticion.codigo == null || peticion.codigo == undefined) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por Diligenciar todos los datos",
          "info");
      } else {
        axios.post("agregar_modulos",peticion)
          .then((respuesta) => {
            if(respuesta.data.codigo == 0){
                this.$swal.fire("Exito", respuesta.data.mensaje, "success")
                this.modulos_activos();
              }else{
                this.$swal.fire("Info", respuesta.data.mensaje, "error")
              }
          }).catch((error) => {
              if(error.response.status == 400){
                 this.$swal.fire(
                  "Ups!!",
                  "Token Invalido Cierre Session e Ingrese de Nuevo",
                  "error"
                );
              }
            });
      }
}});
    },
  },
};

</script>
<style scoped>
.coloriconos{
  color:white;
}
</style>
